import { useSystemLanguage } from '@contexts/SystemLanguageContext';
import { loadRemoteModule } from '@cw-elements/mfe-setup/load';
import { getLanguageTag } from '@utils/translations';
import { Suspense, lazy, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useOutletContext } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import { ModulesError } from './modules-error.component';
import { ModulesLoading } from './modules-loading.component';
import { ModulesOutletContext } from './modules.container';

export interface SubscriptionManagementProps {
  onBackClick: () => void;
  workspaceId: string;
  userId: string;
}

const SubscriptionManagement = lazy<React.FC<SubscriptionManagementProps>>(() =>
  loadRemoteModule('subscriptions/management')
);

function SubscriptionsModule() {
  const { t } = useTranslation();
  const { user } = useOutletContext<ModulesOutletContext>();
  const [params] = useSearchParams();

  const workspaceId = params.get('workspace');
  const languageParam = params.get('language');

  const [_, setLang] = useSystemLanguage();

  const closeSubscription = () => {
    globalThis.Mobile?.subscriptionClosed();
  };

  useEffect(() => {
    if (languageParam) {
      setLang(getLanguageTag(languageParam));
    } else {
      setLang(getLanguageTag(user.locale));
    }
  }, [user, languageParam, setLang]);

  if (!workspaceId) {
    return (
      <ModulesError
        message={t('modules.alerts.missing_workspace.message')}
        description={t('modules.alerts.missing_workspace.description')}
      />
    );
  }

  return (
    <div className="h-screen overflow-y-auto">
      <Suspense fallback={<ModulesLoading />}>
        <SubscriptionManagement
          onBackClick={closeSubscription}
          userId={user.id}
          workspaceId={workspaceId}
        />
      </Suspense>
    </div>
  );
}

export { SubscriptionsModule };
